import React from 'react';
import styled from 'styled-components';
import { useAgilyticsDispatch } from '@agilytics/global-state';
import { GridContainer, Formatted, Button } from '@agilytics/components';
import content from './content.json';
import tableData from './table.json';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacingTriple};
  padding: 0px ${({ theme }) => theme.spacingTriple};
  max-width: 1024px;
  width: 100%;
`;

const TextContainer = styled.div`
  text-align: left;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table,
  td,
  th {
    border: 1px solid ${({ theme }) => theme.colors.accent};
  }
  th {
    text-align: center;
  }
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: ${({ theme }) => theme.fontSizes.legal};
  & > thead > tr > th,
  & > tbody > tr > td {
    padding: ${({ theme }) => theme.spacingDouble};
  }

  @media (max-width: ${({ theme }) => theme.deviceSizes.m}) {
    & > tbody > tr > td {
      padding: ${({ theme }) => theme.spacingDouble};
      padding-top: ${({ theme }) => theme.spacingQuadruple};
    }

    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    & > thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    & tr {
      border: 1px solid ${({ theme }) => theme.colors.accent};
    }

    & td {
      border: none;
      border-bottom: 1px solid ${({ theme }) => theme.colors.outline};
      position: relative;
    }

    & td:before {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 100%;
      white-space: nowrap;
      font-weight: 900;
    }

    ${({ headings }) =>
      headings
        .map(
          (heading, i) =>
            `
              td:nth-of-type(${i + 1}):before {
                content: "${heading}";
              }
            `
        )
        .join('\n')}
  }
`;

const ManageButton = styled(Button)`
  margin: ${({ theme }) => theme.spacingTriple} 0px;
`;

const Code = styled.code`
  display: inline-block;
  margin: ${({ theme }) => theme.spacingBase};
  padding: ${({ theme }) => theme.spacingBase};
  background-color: #eee;
`;

export default function Cookies() {
  const dispatch = useAgilyticsDispatch();

  const showCookiePreferences = () => {
    document.scrollingElement.scrollTop = 0;
    dispatch({ type: 'showCookiePreferences' });
  };

  const renderTable = tableData => {
    const { headings, rows } = tableData;

    return (
      <Table headings={Object.values(headings)}>
        <thead>
          <tr>
            {Object.values(headings).map((heading, i) => (
              <th key={i}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((item, i) => (
                <td key={i}>{Array.isArray(item) ? item.map((key, i) => <Code key={i}>{key}</Code>) : item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <GridContainer>
      <Container>
        <TextContainer>
          <Formatted content={content.content} />
          <ManageButton onClick={showCookiePreferences}>{content.manageText}</ManageButton>
          {renderTable(tableData)}
        </TextContainer>
      </Container>
    </GridContainer>
  );
}
